import DirectDebitMethod from './direct-debit-method';

export default DirectDebitMethod;
